<template>
    <v-expansion-panel :id="'accordion' + name" :key="name">
        <v-expansion-panel-header>{{ title }}</v-expansion-panel-header>
        <v-expansion-panel-content>
                        <slot></slot>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
    export default {
        props: {
            'name': String,
            'title': String,
            'collapsed': Boolean,
            'whiteHeader': Boolean,
        },
        data() {
            return {
                inner_collapsed: this.collapsed,
                inner_index: 0
            }
        },
        watch: {
            collapsed: function () {
                this.inner_collapsed = this.collapsed;
            }
        },
        mounted() {
            EaseEventBus.listen('tap', (data) => {
                this.$nextTick(() => {
                    if (data.index !== this.inner_index) {
                        this.inner_collapsed = true;
                        this.inner_index = data.index;

                        if (this.name === 'fontcollapse' && this.$refs.content) {
                            this.inner_collapsed = false;
                            this.$refs.content.classList.add('collapse', 'in');
                        }
                    }
                });
            });
            EaseEventBus.listen('toggleCollapse', (data) => {
                if (data.name === this.name && this.$refs.content) {
                    if(this.inner_collapsed !== data.collapsed) {
                        if(data.collapsed) {
                            this.inner_collapsed = true;
                            this.$refs.content.classList.add('collapsed');
                            this.$refs.content.classList.remove('in');
                        } else {
                            this.inner_collapsed = false;
                            this.$refs.content.classList.add('collapse', 'in');
                        }
                    }
                    EaseEventBus.fire('toggleCollapseFinished', data);
                }
            });
        }
    }
</script>
